import { useContext, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components/macro";

import API from "Signups/API";
import { SignupsAppState } from "Signups/state.js";

import FnrConfirmationPopover from "UI/FnrConfirmationPopover/FnrConfirmationPopover";
import FnrIcon from "UI/FnrIcon";
import FnrLoadingBricks from "UI/FnrLoadingBricks/FnrLoadingBricks";

import { MoreButton, MoreButtonText } from "./MoreButton";

export default function DuplicateSignup() {
  const history = useHistory();
  const [
    {
      currentSignupList: { ID: signupListID },
    },
    dispatch,
  ] = useContext(SignupsAppState);

  const triggerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(false);

  const duplicateSignup = () => {
    if (isLoading) return;

    setIsLoading(true);

    API.duplicate(signupListID)
      .then((res) => {
        if (res.allSignupLists) {
          dispatch({
            type: "Update All Signup Lists",
            allSignupLists: res.allSignupLists,
          });
        }
        //i don't like this but it was redirecting away from the new signup for some reason
        window.location = `/signups/${res.signupListID}/items`;
      })
      .catch(() => {
        setServerError(true);
        setIsLoading(false);
      });
  };

  const width = window.innerWidth;

  return (
    <>
      <MoreButton onClick={duplicateSignup} ref={triggerRef}>
        {isLoading ? (
          <LoadingWrapper>
            <FnrLoadingBricks show size={16} />
          </LoadingWrapper>
        ) : (
          <>
            <FnrIcon far fa-copy />
            <MoreButtonText>Duplicate Signup</MoreButtonText>
          </>
        )}
      </MoreButton>

      <FnrConfirmationPopover
        show={serverError}
        ref={triggerRef}
        onClose={() => setServerError(false)}
        message={
          <div>
            Something went wrong! Please try again or contact{" "}
            <a
              href="mailto:help@flocknote.com"
              target="_blank"
              rel="noreferrer"
            >
              help@flocknote.com
            </a>
            .
          </div>
        }
        color="red"
        style={{ maxWidth: 220, padding: 10 }}
      />
    </>
  );
}

const LoadingWrapper = styled.div`
  width: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
